var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-content has-text-centered" }, [
      _vm.title
        ? _c("h1", { staticClass: "title is-3", class: _vm.classTitle }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _c("h1", { staticClass: "title is-3" }, [
            _vm._v("Está por realizar una acción"),
          ]),
      _vm._v(" "),
      _vm.subtitle
        ? _c("h2", {
            staticClass: "subtitle is-5",
            domProps: { innerHTML: _vm._s(_vm.subtitle) },
          })
        : _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("¿Está seguro?")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: { click: _vm.cancel },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "card-footer-item has-text-weight-bold is-uppercase",
          class: _vm.actionClass,
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.accept.apply(null, arguments)
            },
          },
        },
        [_vm._v(_vm._s(_vm.actionText || "Aceptar"))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }